import React, { useEffect, useState, useRef } from 'react';
import { Play, Pause } from 'lucide-react';
import { motion } from 'framer-motion';
export function AudioPlayer() {
  const [isPlaying, setIsPlaying] = useState(false);
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);
  const audioRef = useRef<HTMLAudioElement>(null);
  const audioUrl = 'https://cdn.shopify.com/s/files/1/0586/4069/5378/files/Tiasser01.wav?v=1770226892';
  useEffect(() => {
    const audio = audioRef.current;
    if (!audio) return;
    const updateTime = () => setCurrentTime(audio.currentTime);
    const updateDuration = () => setDuration(audio.duration);
    const handleEnded = () => setIsPlaying(false);
    audio.addEventListener('timeupdate', updateTime);
    audio.addEventListener('loadedmetadata', updateDuration);
    audio.addEventListener('ended', handleEnded);
    return () => {
      audio.removeEventListener('timeupdate', updateTime);
      audio.removeEventListener('loadedmetadata', updateDuration);
      audio.removeEventListener('ended', handleEnded);
    };
  }, []);
  const togglePlay = () => {
    const audio = audioRef.current;
    if (!audio) return;
    if (isPlaying) {
      audio.pause();
    } else {
      audio.play();
    }
    setIsPlaying(!isPlaying);
  };
  const formatTime = (time: number) => {
    const minutes = Math.floor(time / 60);
    const seconds = Math.floor(time % 60);
    return `${minutes}:${seconds.toString().padStart(2, '0')}`;
  };
  const progress = duration > 0 ? currentTime / duration * 100 : 0;
  return <div className="w-full bg-[#F5F0EB] rounded-2xl p-5 md:p-6 shadow-sm border border-[#E8E2DB]" data-id="element-137">
      <audio ref={audioRef} src={audioUrl} preload="metadata" data-id="element-138" />

      <div className="flex flex-col md:flex-row items-center gap-5 md:gap-6" data-id="element-139">
        {/* Play Button Container */}
        <div className="relative flex-shrink-0" data-id="element-140">
          {/* Breathing Ring Animation */}
          {!isPlaying && <motion.div className="absolute inset-0 bg-[#C4856A] rounded-full opacity-20" animate={{
          scale: [1, 1.2, 1]
        }} transition={{
          duration: 3,
          repeat: Infinity,
          ease: 'easeInOut'
        }} data-id="element-141" />}

          <button onClick={togglePlay} className="relative z-10 w-14 h-14 md:w-16 md:h-16 bg-[#C4856A] hover:bg-[#B07459] text-white rounded-full flex items-center justify-center transition-colors duration-300 focus:outline-none focus:ring-4 focus:ring-[#C4856A]/30" aria-label={isPlaying ? 'Pause preview' : 'Play preview'} data-id="element-142">
            {isPlaying ? <Pause className="w-5 h-5 md:w-6 md:h-6 fill-current" data-id="element-143" /> : <Play className="w-5 h-5 md:w-6 md:h-6 fill-current ml-1" data-id="element-144" />}
          </button>
        </div>

        {/* Player Info */}
        <div className="flex-1 w-full text-center md:text-left" data-id="element-145">
          <div className="mb-2" data-id="element-146">
            <span className="text-xs font-semibold tracking-widest text-[#C4856A] uppercase" data-id="element-147">
              Audio Preview
            </span>
            <h3 className="text-base md:text-lg font-medium text-[#2D2A26] mt-1 font-serif italic" data-id="element-148">
              "The Signal You're Broadcasting"
            </h3>
          </div>

          {/* Progress Bar */}
          <div className="relative h-2 bg-[#E0D8D0] rounded-full overflow-hidden mt-3" data-id="element-149">
            <div className="absolute top-0 left-0 h-full bg-[#C4856A] transition-all duration-100" style={{
            width: `${progress}%`
          }} data-id="element-150" />
          </div>

          <div className="flex justify-between text-xs text-[#8A8580] mt-2 font-medium" data-id="element-151">
            <span data-id="element-152">{formatTime(currentTime)}</span>
            <span data-id="element-153">{duration > 0 ? formatTime(duration) : '--:--'}</span>
          </div>
        </div>
      </div>
    </div>;
}